/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Requisition DataTable
 * Description: Requisition DataTable
 * Date: 05/06/2022
 */

import { Badge } from 'react-bootstrap';
import useDataTable from '../../../hooks/useDataTable';

export default function RequisitionTable({ data }) {
    const conditionalCellStyles = [
        {
            when: (row) => Number(row.central_available_qty) <= 0,
            style: {
                backgroundColor: '#ffb4c1',
            },
        },
    ];

    const columns = [
        {
            name: 'Item Names',
            selector: (row) => row.drug_name,
            sortable: true,
            conditionalCellStyles,
            wrap: true,
            grow: 2,
            fixed: true,
        },
        {
            name: 'Category Name',
            selector: (row) => row.category_name,
            sortable: true,
            conditionalCellStyles,
        },
        {
            name: 'Status',
            sortable: true,
            conditionalCellStyles,
            cell: (row) =>
                row.status === 'distributed' ? (
                    <Badge className="badgeActive" bg="success">
                        Distributed
                    </Badge>
                ) : row.status === 'approved' ? (
                    <Badge className="badgeActive" bg="success">
                        Approved
                    </Badge>
                ) : row.status === 'recevied' ? (
                    <Badge className="badgeActive" bg="success">
                        Recevied
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Pending
                    </Badge>
                ),
        },
        {
            name: 'Partner Requested Qty',
            selector: (row) => row.approve_qty,
            sortable: true,
        },
        {
            name: 'Central Distribute Qty',
            selector: (row) => row.central_distributed_qty,
            sortable: true,
            conditionalCellStyles,
        },
        {
            name: 'Received Qty',
            selector: (row) => row.partner_received_qty,
            sortable: true,
        },
        {
            name: 'Rejected Qty',
            selector: (row) => row.partner_rejected_qty,
            sortable: true,
        },
        {
            name: 'Rejected Reason',
            selector: (row) => row.partner_reject_reason,
            sortable: true,
        },
    ];

    const search_column = {
        // drug_name: 'Name',
    };
    return useDataTable({ columns, data, search_column, pagination: false });
}
